<template>
    <section class="container__ main" style="position: relative; margin: 0 auto" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">

        <v-container style="position: relative; max-width: 1200px; margin: 0 auto">
            <v-row justify="center" >
                <v-col class="link-col" v-for="(link,index) in block.links" :key="index" :cols="cols" style="position: relative">
                    <link-item :link="link"></link-item>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
    import LinkItem from "./Items/LinksItem"

    export default {
        props:["block"],
        components:{LinkItem},
        name: "LinksBlock",
        data(){
            return {
            }
        },
        computed: {
            cols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md':
                        switch(this.block.links.length){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'lg':
                        switch(this.block.links.length){
                        case 1: return 12
                        case 2: return 6
                        case 3: return 4
                        case 4: return 3
                    }
                        break
                    case 'xl':
                        switch(this.block.links.length){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                }
                return false
            },
        },
    }
</script>

<style scoped>
    .container{
        min-height: 250px;
    }

    .color-picker-closer{
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
    }

    .color-picker{
        position: absolute;
        z-index: 100;
        bottom: 0;
        right: 0
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }




</style>